import React from 'react';
import {motion} from 'motion/react';
import * as api from '../../services/fissionBoard';
import {
  Button,
  Image,
  Space,
  // Popover
} from 'antd-mobile';
import {goTo, toPriceStr} from '@utils';
// import {useFocusEffect} from '@react-navigation/native';

// 添加全局样式来自定义Popover
const popoverStyles = `
  .custom-popover .adm-popover-inner {
    background-color: #E14718 !important;
    color: white !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 100px !important;
  }
  .custom-popover .adm-popover-inner-content {
    --content-padding: 5px 8px;
  }
  
  .custom-popover .adm-popover-arrow {
    border-top-color: #E14718 !important;
    border-bottom-color: #E14718 !important;
    border-left-color: #E14718 !important;
    border-right-color: #E14718 !important;
    color: #E14718;
  }
  
  .custom-popover .adm-popover-arrow::before {
    background-color: #E14718 !important;
  }
`;

// 注入样式
if (
  typeof document !== 'undefined' &&
  !document.querySelector('#custom-popover-styles')
) {
  const styleElement = document.createElement('style');
  styleElement.id = 'custom-popover-styles';
  styleElement.textContent = popoverStyles;
  document.head.appendChild(styleElement);
}

interface FissionUserRankProps {
  myRanking: api.GetMyRankingResponse | null;
  loading?: boolean;
}

const FissionUserRank: React.FC<FissionUserRankProps> = ({
  myRanking,
  loading = false,
}) => {
  // const [visible, setVisible] = useState(false);
  // useFocusEffect(() => {
  //   setVisible(true);
  //   return () => setVisible(false);
  // });
  if (loading) {
    return (
      <motion.div
        initial={{y: 100, opacity: 0}}
        animate={{y: 0, opacity: 1}}
        transition={{duration: 0.3, delay: 0.2}}
        className="fixed bottom-0 left-0 right-0 z-20 h-20 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
      </motion.div>
    );
  }

  if (!myRanking) {
    return (
      <motion.div
        initial={{y: 100, opacity: 0}}
        animate={{y: 0, opacity: 1}}
        transition={{duration: 0.3, delay: 0.2}}
        className="fixed bottom-0 left-0 right-0 z-20 h-20 flex items-center justify-center">
        <div className="text-white/60">未上榜</div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{y: 100, opacity: 0}}
      animate={{y: 0, opacity: 1}}
      transition={{duration: 0.3, delay: 0.2}}
      className="fixed bottom-0 left-0 right-0 z-20 h-[4.625rem] bg-[#fff5eb] rounded-t-[1.25rem] shadow-[0_-10px_20px_0_rgba(223,129,87,0.54),_inset_0_2px_2px_0_rgba(255,255,255,0.25)]
">
      <div className="flex items-center h-full px-[0.3125rem]">
        <div className="text-[#02221D] text-lg font-semibold">
          {myRanking.ranking || '--'}
        </div>
        <Image
          className="border rounded-full size-[2.375rem] ml-2"
          src={myRanking.userAvatar}
        />
        <div className="ml-1.5 flex flex-col justify-between">
          <div>{myRanking.userName || '--'}</div>
          <Space>
            <Image
              src={require('../../assets/person.webp')}
              className="w-5 h-4"
            />
            <span className="text-[#F3860A] text-sm font-bold">
              {myRanking.inviteTotalCount}
            </span>
          </Space>
        </div>
        {/*<Popover*/}
        {/*  content={`Inviting users can get up to ${toPriceStr(*/}
        {/*    myRanking.bonusAmount,*/}
        {/*    {*/}
        {/*      overPrice: 10000,*/}
        {/*      fixed: 0,*/}
        {/*      suffixUnit: 'K',*/}
        {/*      showCurrency: true,*/}
        {/*    },*/}
        {/*  )}`}*/}
        {/*  placement="top"*/}
        {/*  getContainer={null}*/}
        {/*  visible={visible}*/}
        {/*  className="custom-popover">*/}
        {/*  <Button*/}
        {/*    className="bg-[#166BE5] ml-auto rounded-full w-[5.9375rem] text-white overflow-hidden"*/}
        {/*    onClick={() => {*/}
        {/*      goTo('Invitation');*/}
        {/*    }}>*/}
        {/*    INVITE*/}
        {/*  </Button>*/}
        {/*</Popover>*/}
        <Button
          className="bg-[#166BE5] ml-auto rounded-full w-[5.9375rem] text-white overflow-hidden"
          onClick={() => {
            goTo('Invitation');
          }}>
          INVITE
        </Button>
        <Space className="ml-1">
          <Image src={require('../../assets/coin.webp')} className="size-5" />
          <span className="text-[#F3860A] text-sm font-bold">
            {toPriceStr(myRanking.bonusAmount, {
              fixed: 0,
              suffixUnit: 'K',
              overPrice: 10000,
            })}
          </span>
        </Space>
      </div>
    </motion.div>
  );
};

export default FissionUserRank;
